export default "//static.tradera.net/touchweb/static/output/images/category-currency.a71976ce.svg";